// eslint-disable-next-line import/prefer-default-export
export { PaginationConfig } from '../pagination';
